import * as React from 'react';
import * as Header from '../constants/Header';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

import ForgotPasswordForm from '../containers/ForgotPasswordForm';

class DoneForgotPassword extends React.Component {
  render() {
    return (
      <div>
        <div id="procedureFinished" className="forgotPassword">
          <h2>パスワード再設定手続きを開始しました。</h2>
          <p>&nbsp;</p>
          <p>ご契約時のメールアドレスにメールを送信しました。</p>
          <p>メールを確認して手続きを行って下さい。</p>
          <p>手続きは、１時間以内に行って下さい。1時間を超えると期限切れになるので、手続きをやり直して下さい。</p>
        </div>
      </div>
    );
  }
}

interface ForgotPasswordProps extends React.Props<{}> {
  headerActions?: any;
  password: any;
  passwordActions: any;
}

class ForgotPassword extends React.Component<ForgotPasswordProps, {}> {
  static propTypes = {
    password: PropTypes.any.isRequired,
    passwordActions: PropTypes.any.isRequired,
  };

  constructor (props: any) {
    super(props);
  }

  componentWillMount() {
    document.title = '管理';
    this.props.headerActions.setPage(Header.SETTING_FORGOT_PASSWORD);
  }

  render() {
    return (
      <div>
        {
          (() => {
            if (this.props.password.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        {(this.props.password.Loaded) ? (
          (this.props.password.result) ?
            <DoneForgotPassword key="message" /> : <ForgotPasswordForm key="form" />
          ) :
            (null)
        }
      </div>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.tsx